import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from '../../common/components/LoadingSpinner';
import { Link } from 'react-router-dom';
import TableHeader from './TableHeader';

function StimsTable({ stims, loading, handleSortChange, currentOrderBy, onStimsSelection}) {
  const [selectedStims, setSelectedStims] = useState([]);

  const handleCheckboxChange = (e, stimId) => {
    const isChecked = e.target.checked;
    console.log(`Stim ID: ${stimId}, Checked: ${isChecked}`);
    setSelectedStims((prevSelected) => //updates selectedstims
      isChecked
        ? [...prevSelected, stimId] 
        : prevSelected.filter((id) => id !== stimId) 
    );
    onStimsSelection(isChecked ? [...selectedStims, stimId] : selectedStims.filter((id) => id !== stimId)); 
  };
  if (loading) {
    return <LoadingSpinner />;
  }

  const tableHeadings = [
  { name: "STIM ID" },
  { name: "Name" },
  { name: "Ad Type" },
  { name: "Brand" },
  { name: "Country" },
  { name: "Language" },
  { name: "Clutter" },
  { name: "Upload Date" },
  { name: "AOI" },
];

  const isClutter = (v) => {
    if (v === true) return true;
    if (v === false) return false;
    if (v === 1) return true;
    if (v === 0) return false;

    if (typeof v === "string") {
      const s = v.trim().toLowerCase();
      if (["true", "1", "t", "yes", "y"].includes(s)) return true;
      if (["false", "0", "f", "no", "n"].includes(s)) return false;
    }

    return false;
  };

  return (
    
    <table className="stims table" style={{ tableLayout: "fixed",width: "100%" }}>
<colgroup>
  <col style={{ width: "40px" }} />
  <col style={{ width: "60px" }} />
  <col style={{ width: "200px" }} />
  <col style={{ width: "120px" }} />
  <col style={{ width: "150px" }} />
  <col style={{ width: "120px" }} />
  <col style={{ width: "120px" }} />
  <col style={{ width: "70px" }} />
  <col style={{ width: "100px" }} />
  <col style={{ width: "90px" }} />
</colgroup>
      <thead>
        <TableHeader 
          currentOrderBy={currentOrderBy} 
          handleSortChange={handleSortChange} 
          data={tableHeadings}
        />
      </thead>
      <tbody>
        {stims.map((item, index) => (
          <tr key={index}>
            <td>
              <input
                type="checkbox"
                checked={selectedStims.includes(item.id)} 
                onChange={(e) => handleCheckboxChange(e, item.id)} 
                 style={{
                  width: "16px",
                  height: "16px",
                  display: "inline-block",
                  visibility: "visible",
                  position: "relative",
                  margin: "0 auto"
                  }}
              />
            </td>
         

      <td>{item.id}</td>
    <td style={{ overflow: "hidden" }}>
      <Link to={`/stims/edit/${item.id}`} style={{ display: "block" }}>
        <div
          style={{
            whiteSpace:"normal",
            wordBreak:"break-word",
            overflowWrap:"break-word",
          }}
        >
          {item.name}
        </div>
      </Link>
    </td>
      <td>{item.ad_type_name || item.ad_type || "-"}</td>
      <td>{item.brand}</td>
      <td>{item.country || "-"}</td>
      <td>{item.language || "-"}</td>
      <td>{isClutter(item.clutter) ? "Clutter" : "Test"}</td>
      <td>
        {item.created ? String(item.created).slice(0, 10) : "-"}
      </td>

            <td className="links__table-headings">
              <Link to={`/stims/aoi/${item.id}?type=stim`}>
                <div className="button-primary" style={{padding:"4px 12px"}}>AOI</div>
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

StimsTable.propTypes = {
  loading: PropTypes.bool,
  stims: PropTypes.array.isRequired,
  handleSortChange: PropTypes.func.isRequired,
  currentOrderBy: PropTypes.string.isRequired,
  onStimsSelection: PropTypes.func.isRequired,
};

export default StimsTable;